import { format } from 'date-fns'
import Link from 'next/link'
import DealCard from './pageBuilderBlocks/partials/DealCard'
import FeaturedDeals from './pageBuilderBlocks/FeaturedDeals';
import{ formatCurrency } from '../../lib/helpers/currencyFormatter'

interface DealsListProps {
	deals: any
	featuredDeals?: any
	heading?: any
	link?: any
}

const DealsList = (props: DealsListProps) => {

	const { deals, heading, featuredDeals, link } = props

	if ( deals.length === 0 ) {
		return null
	}

	return (

		<section className="content-container">
			{heading || link ? (
				<header className="content-container__header-wrapper">
					<div className="content-container__header-title">
						<h2>{heading}</h2>
					</div>
					<div className="content-container__header-cta">
						{link && <Link href="/deals" className='button button--inverted'>See all deals →</Link>}
					</div>
				</header>
			) : null}
			
			{featuredDeals && <FeaturedDeals key={null} block={null} deals={featuredDeals} background="white"/>}

			<div className="flex-table">
				<div className="flex-table__row flex-table__row--header">
					<div className="flex-table__row-inner">
						<div className="flex-table__column flex-table__column--deals-sector">Sector</div>
						<div className="flex-table__column flex-table__column--deals-company">Type</div>
						<div className="flex-table__column flex-table__column--deals-title">Title</div>
						<div className="flex-table__column flex-table__column--deals-value">Value</div>
						<div className="flex-table__column flex-table__column--deals-date">Date</div>
					</div>
				</div>
				{deals.map((deal: any) => {
					// Render featured deal as a card
					// if ( deal.featured ) {
					// 	return <DealCard deal={deal} key={deal.id} />
					// }

					const sector = deal.relatedSectors && deal.relatedSectors.length > 0 ? deal.relatedSectors[0] : null

					return (
						<Link href={`/${deal.uri}`} key={deal.id} className="flex-table__row flex-table__row--content deal-link">
							<div className="flex-table__row-inner">
								<div className="flex-table__column flex-table__column--deals-sector">
									{sector && <Link href={`/${sector.uri}`} className='button button--inverted'>{sector.title}</Link>}
								</div>
								<div className="flex-table__column flex-table__column--deals-company">{deal.dealType[0] ? deal.dealType[0].title : ''}</div>
								<div className="flex-table__column flex-table__column--deals-title">
									<strong>{deal.company}</strong>{deal.description ? ` — ${deal.description}` : null}
								</div>
								<div className="flex-table__column flex-table__column--deals-value">
									{formatCurrency(deal.dealCurrency, deal.dealAmount)}
								</div>
								<div className="flex-table__column flex-table__column--deals-date">{format(new Date(deal.postDate), 'MMMM yyyy')}</div>
							</div>
						</Link>
					)
				})}
			</div>
		</section>

	)

}
export default DealsList
